import React, { useState } from 'react';
import TermsOfUseView from './TermsOfUseView';
import PrivacyPolicyView from './PrivacyPolicyView';
import CookiesPolicyView from './CookiesPolicyView';

const LegalView = ({ onBack }) => {
  const [subView, setSubView] = useState(null);

  if (subView === 'terms') {
    return <TermsOfUseView onBack={() => setSubView(null)} />;
  }
  if (subView === 'privacypolicy') {
    return <PrivacyPolicyView onBack={() => setSubView(null)} />;
  }
  if (subView === 'cookies') {
    return <CookiesPolicyView onBack={() => setSubView(null)} />;
  }

  return (
    <div className="min-h-screen bg-black text-white">
      <div className="max-w-3xl mx-auto px-4 py-8">
        {onBack && (
          <button
            onClick={onBack}
            className="mb-6 text-[#22c55e] hover:text-[#16a34a] flex items-center space-x-1 text-sm"
          >
            <span>← Back</span>
          </button>
        )}
        <h1 className="text-3xl font-bold text-white mb-2">Legal</h1>
        <p className="text-gray-400 text-sm mb-8">Loft Golf, LLC · Brooklyn, NY 11209 · contact@loftgolf.app</p>

        <div className="space-y-4">
          <button
            onClick={() => setSubView('terms')}
            className="w-full bg-gray-900 border border-gray-700 rounded-xl p-5 text-left hover:border-[#22c55e] transition-colors"
          >
            <h2 className="text-lg font-bold text-white mb-1">Terms of Use</h2>
            <p className="text-gray-400 text-sm">Last updated April 01, 2026 · The rules and conditions governing your use of Loft.</p>
          </button>

          <button
            onClick={() => setSubView('privacypolicy')}
            className="w-full bg-gray-900 border border-gray-700 rounded-xl p-5 text-left hover:border-[#22c55e] transition-colors"
          >
            <h2 className="text-lg font-bold text-white mb-1">Privacy Policy</h2>
            <p className="text-gray-400 text-sm">Last updated April 01, 2026 · How we collect, use, and protect your personal information.</p>
          </button>

          <button
            onClick={() => setSubView('cookies')}
            className="w-full bg-gray-900 border border-gray-700 rounded-xl p-5 text-left hover:border-[#22c55e] transition-colors"
          >
            <h2 className="text-lg font-bold text-white mb-1">Cookies Policy</h2>
            <p className="text-gray-400 text-sm">Last updated April 8, 2026 · What cookies we use and how you can control them.</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LegalView;
